const state = {
  lifeinpaxel: [],
  lifeinpaxel_id: [],
};

export default state;
